import React from "react";
import noop from 'lodash/noop';
import defaultLocale from "./default-locale";
export var StaticContext = /*#__PURE__*/React.createContext({});
export var LocaleContext = /*#__PURE__*/React.createContext(defaultLocale);
export var LayoutContext = /*#__PURE__*/React.createContext({
  setToolbarHeight: noop,
  setHeaderHeight: noop
});
export var SelectionContext = /*#__PURE__*/React.createContext({
  enabled: false,
  selectedRowKeys: [],
  isSelected: function isSelected() {
    return false;
  },
  isIndeterminate: function isIndeterminate() {
    return false;
  },
  noneSelected: true,
  allSelected: false,
  indeterminate: false,
  getProps: function getProps() {
    return {};
  },
  select: noop,
  selectAll: noop,
  getSelectedRecords: function getSelectedRecords() {
    return [];
  }
});
export var PaginationContext = /*#__PURE__*/React.createContext({});